import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/rootReducer';

import { composeWithDevTools } from 'redux-devtools-extension';


const initialState = {};

const middleware = [thunk];
let store;
if (process.env.NODE_ENV === 'development') {
  store = createStore(
    rootReducer,
    initialState,
    composeWithDevTools(
      applyMiddleware(...middleware),
    )
  );
} else {
  store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middleware),
  );
}

export default store;


// WEBPACK FOOTER //
// ./src/store/store.js